export function matchHeight() {
  $(function() {
    $('.js-matchHeight').matchHeight();
  });
}